import { Switch as AntdSwitch } from 'antd';
import styled from 'styled-components';

const getHandleSpace = (size?: string) => {
  switch (size) {
    case 'sm':
      return 22;
    case 'md':
      return 24;
    case 'lg':
      return 28;
    default:
      return 28;
  }
};

const getHandleSize = (size?: string) => {
  switch (size) {
    case 'sm':
      return 16;
    case 'md':
      return 20;
    case 'lg':
      return 24;
    default:
      return 24;
  }
};

export const StyledSwitch = styled(AntdSwitch)<{ size?: string }>`
  min-width: ${props => (props.size === 'sm' ? 36 : 48)}px;
  height: ${props => (props.size === 'sm' ? 24 : props.size === 'md' ? 28 : 32)}px;
  background-color: rgba(0, 0, 0, 0.08);

  .ant-switch-handle {
    background-color: ${props => props.theme.colors.secondary.light.contentBg};
    border-radius: 9999px;
    width: ${props => getHandleSize(props.size)}px;
    height: ${props => getHandleSize(props.size)}px;
    top: 50%;
    left: 4px;
    transform: translateY(-50%);
  }

  .ant-switch-handle::before {
    border-radius: 9999px;
  }

  &.ant-switch-checked {
    background-color: ${props => props.theme.colors.primary.main.filled};

    .ant-switch-handle {
      left: calc(100% - ${props => getHandleSpace(props.size)}px) !important;
    }
  }
`;
